import { _ } from "../../core/polyglot/polyglot.js";
import accountingDocument from "../shared/accountingDocument.js";
import ReportDisclaimerWidget from "../../core/widgets/ReportDisclaimerWidget.js";
import session from "../../core/session.js";
import TitleWidget from "../../core/chrome/TitleWidget.js";

/**
 * Render the current company's report disclaimer.
 */
const disclaimerDocument = accountingDocument.subclass((that, my) => {
	my.initialize = function () {
		my.super(...arguments);

		that.documentId = "disclaimer";

		that.title = _("Disclaimer");
	};

	my.initializeSubwidgets = function () {
		my.super(...arguments);

		my.titleWidget = new TitleWidget({
			title: that.title,
			subtitle: that.subtitle,
		});

		my.reportDisclaimerWidget = new ReportDisclaimerWidget({
			company: session.getCompany(),
			agency: session.agency,
			period: session.getPeriod(),
		});
	};

	that.hasPeriodPicker = function () {
		return false;
	};

	that.hasActionsMenu = function () {
		return false;
	};

	my.renderContentOn = function (html) {
		html.render(my.reportDisclaimerWidget);
	};
});

export default disclaimerDocument;
